<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div
        class="sidebar-content card show"
      >
        <!-- ScrollArea: Chat & Contacts -->
        <vue-perfect-scrollbar
          :settings="perfectScrollbarSettings"
          class="chat-user-list-wrapper list-group scroll-area"
        >
          <b-card
            class="card-transaction"
            no-body
          >
            <b-card-header>
              <b-card-title>Reclutamiento</b-card-title>

              <b-button
                variant="primary"
                @click="$emit('open-modal-ficha'); $emit('close-left-sidebar')"
              >
                <span class="text-nowrap">Nuevo</span>
              </b-button>
            </b-card-header>
          </b-card>
          <div
            v-if="isBusy"
            class="text-center text-primary my-2"
          >
            <b-spinner
              variant="primary"
              class="align-middle"
            />
            <strong class="ml-1">Cargando...</strong>
          </div>
          <ul class="chat-users-list chat-list media-list">
            <component
              :is="tag"
              v-for="ficha in fichas.items"
              :key="'ficha-' + ficha.idFichaReclutamiento"
              class="li-ficha"
              :class="{'active': activeFichaId === ficha.idFichaReclutamiento}"
              @click="$emit('open-ficha', ficha.idFichaReclutamiento)"
            >
              <b-avatar
                square
                size="42"
                :src="resolveAvatar(ficha.etapa)"
                badge
                class="badge-minimal"
                :badge-variant="resolveBadge(ficha.etapa)"
                variant="transparent"
              />
              <div class="chat-info flex-grow-1">
                <h5 class="mb-0">
                  {{ ficha.ubigeo.descripcion }}
                </h5>
                <p class="card-text text-truncate">
                  San Martín / Moyobamba
                </p>
              </div>
              <div
                class="chat-meta text-nowrap"
              >
                <small class="float-right mb-25 chat-time">{{ getDateFmt(ficha.fecha) }}</small>
                <b-badge
                  pill
                  variant="primary"
                  class="float-right"
                >
                  3
                </b-badge>
              </div>
              <b-dropdown
                variant="link"
                no-caret
                class="chart-dropdown"
                toggle-class="p-0"
                right
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="18"
                    class="text-body cursor-pointer"
                  />
                </template>
                <b-dropdown-item>
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Editar</span>
                </b-dropdown-item>
                <b-dropdown-item>
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Eliminar</span>
                </b-dropdown-item>
              </b-dropdown>
            </component>
          </ul>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import {
  ref,
  // ref, watch, computed, onUnmounted,
} from '@vue/composition-api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  BAvatar, BCard, BCardHeader, BCardTitle, BCardBody, BButton, BDropdown, BDropdownItem, BListGroup, BListGroupItem, BBadge, BSpinner,
} from 'bootstrap-vue'
import { isDynamicRouteActive } from '@core/utils/utils'
import Ripple from 'vue-ripple-directive'
import moment from 'moment'

export default {
  directives: {
    Ripple,
  },
  components: {

    // BSV
    BAvatar,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BButton,
    BDropdown,
    BDropdownItem,
    BListGroup,
    BListGroupItem,
    BBadge,
    BSpinner,

    // 3rd Party
    VuePerfectScrollbar,
  },
  props: {
    emailsMeta: {
      type: Object,
      required: true,
    },
    activeFichaId: {
      type: Number,
      default: null,
    },
  },
  setup() {
    const isBusy = ref(false)
    const tag = ref('li')
    const fichas = ref({})
    const displayFicha = require('@/assets/images/palmas/ficha.png')
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
    }

    const getFichas = async () => {
      isBusy.value = true
      await store
        .dispatch('reclutamiento/FICHA_FIND_ALL', {
          etapa: [0, 1, 2],
          idUsuario: 1,
          limit: 50,
          query: '',
          page: 1,
          sortBy: 'idFichaReclutamiento%7CDESC',
        })
        .then(response => {
          fichas.value = response
        })
        .catch(error => {
          this.showError(error)
          this.isBusyS = false
        })
      isBusy.value = false
    }

    getFichas()

    const resolveAvatar = etapa => {
      if (etapa === 1) {
        return require('@/assets/images/palmas/ficha.png')
      }
      return require('@/assets/images/palmas/fichaclose.png')
    }

    const resolveBadge = etapa => {
      if (etapa === 1) {
        return 'success'
      }
      return 'secondary'
    }

    const emailFilters = [
      { title: 'Inbox', icon: 'MailIcon', route: { name: 'apps-email' } },
      { title: 'Sent', icon: 'SendIcon', route: { name: 'apps-email-folder', params: { folder: 'sent' } } },
      { title: 'Draft', icon: 'Edit2Icon', route: { name: 'apps-email-folder', params: { folder: 'draft' } } },
      { title: 'Starred', icon: 'StarIcon', route: { name: 'apps-email-folder', params: { folder: 'starred' } } },
      { title: 'Spam', icon: 'InfoIcon', route: { name: 'apps-email-folder', params: { folder: 'spam' } } },
      { title: 'Trash', icon: 'TrashIcon', route: { name: 'apps-email-folder', params: { folder: 'trash' } } },
    ]

    const emailLabel = [
      { title: 'Personal', color: 'success', route: { name: 'apps-email-label', params: { label: 'personal' } } },
      { title: 'Company', color: 'primary', route: { name: 'apps-email-label', params: { label: 'company' } } },
      { title: 'Important', color: 'warning', route: { name: 'apps-email-label', params: { label: 'important' } } },
      { title: 'Private', color: 'danger', route: { name: 'apps-email-label', params: { label: 'private' } } },
    ]

    const resolveFilterBadgeColor = filter => {
      if (filter === 'Draft') return 'light-warning'
      if (filter === 'Spam') return 'light-danger'
      return 'light-primary'
    }

    const getDateFmt = fecha => {
      console.log(fecha)
      return moment(String(fecha)).format('DD-MM-YYYY')
    }

    return {
      // UI
      perfectScrollbarSettings,
      isDynamicRouteActive,
      resolveFilterBadgeColor,

      // Filter & Labels
      emailFilters,
      emailLabel,

      // Fichas
      isBusy,
      resolveAvatar,
      resolveBadge,
      tag,
      displayFicha,
      getDateFmt,
      getFichas,
      fichas,
    }
  },
}
</script>

<style>

</style>
